/*!
 * Consegna stimata – Shoebuya
 * Calcola data di spedizione e consegna in base alla giacenza della variante,
 * saltando sabati, domeniche e festivi italiani.
 *
 * Regole:
 *  - quantità >= 1 (qualsiasi impostazione "vendi quando esaurito")  -> disponibile: spedizione oggi se entro le 14
 *                                                                       (altrimenti giorno lavorativo dopo), consegna +3 gg lavorativi
 *  - quantità <= 0 e "vendi quando esaurito" ATTIVO                   -> ordinabile: spedizione +7 gg lavorativi dall'ordine,
 *                                                                       consegna +3/4 gg lavorativi dalla spedizione
 *  - quantità <= 0 e "vendi quando esaurito" NON attivo               -> non mostrato
 *  - inventario non tracciato                                          -> trattato come in magazzino
 *
 * Carica questo file in layout/theme.liquid (prima di </body>):
 *   <script src="{{ 'consegna-stimata.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  var CFG = (typeof window !== 'undefined' && window.ConsegnaStimataConfig) || {};

  // ---------- IMPOSTAZIONI (modificabili) ----------
  var TZ = 'Europe/Rome';
  var CUTOFF_HOUR = CFG.cutoffHour != null ? CFG.cutoffHour : 14; // disponibili: ordini entro le 14:00 partono in giornata
  var STOCK_DELIVERY = 3;             // disponibili: consegna 3 giorni lavorativi dopo la spedizione
  var ORD_SHIP = 7;                   // ordinabili: spedizione 7 giorni lavorativi dopo l'ordine
  var ORD_MIN = 3, ORD_MAX = 4;       // ordinabili: consegna 3–4 giorni lavorativi dopo la spedizione
  var CLOSED_DAYS = CFG.closedDays || []; // chiusure extra, es. ['2026-12-24', '2026-12-31']

  var PROP = 'Consegna indicativa';   // visibile: carrello, checkout, email
  var PROP_TYPE = '_consegna_tipo';   // nascosta (inizia con _)
  var PROP_CALC = '_consegna_calcolo';// nascosta: data di spedizione usata nel calcolo

  var WD = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];
  var MO = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];

  // ---------- DATE ----------
  function romeNow() {
    var base = CFG.now ? new Date(CFG.now) : new Date();
    var f = new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    });
    var o = {};
    f.formatToParts(base).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: (+o.hour) % 24, min: +o.minute };
  }
  function mk(y, m, d) { return new Date(Date.UTC(y, m - 1, d)); }
  function key(dt) { return dt.toISOString().slice(0, 10); }
  function plus(dt, n) { var r = new Date(dt); r.setUTCDate(r.getUTCDate() + n); return r; }

  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
        h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
        month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return mk(y, month, day);
  }

  var holidayCache = {};
  function holidays(y) {
    if (holidayCache[y]) return holidayCache[y];
    var set = {};
    ['01-01', '01-06', '04-25', '05-01', '06-02', '08-15', '11-01', '12-08', '12-25', '12-26']
      .forEach(function (md) { set[y + '-' + md] = true; });
    set[key(plus(easter(y), 1))] = true; // Lunedì dell'Angelo
    CLOSED_DAYS.forEach(function (d) { if (d.indexOf(String(y)) === 0) set[d] = true; });
    return (holidayCache[y] = set);
  }
  function isWorkday(dt) {
    var w = dt.getUTCDay();
    if (w === 0 || w === 6) return false;
    return !holidays(dt.getUTCFullYear())[key(dt)];
  }
  function addWorkdays(dt, n) {
    var r = new Date(dt);
    while (n > 0) { r = plus(r, 1); if (isWorkday(r)) n--; }
    return r;
  }
  function nextWorkday(dt) { var r = plus(dt, 1); while (!isWorkday(r)) r = plus(r, 1); return r; }

  function estimate(tipo) {
    var now = romeNow();
    var today = mk(now.y, now.m, now.d);
    var shipsToday = isWorkday(today) && now.h < CUTOFF_HOUR;
    var ship = shipsToday ? today : nextWorkday(today);
    var r = { tipo: tipo, order: today, ship: ship, shipsToday: shipsToday, now: now };
    if (tipo === 'stock') {
      r.shipFrom = r.shipTo = ship;
      r.from = r.to = addWorkdays(ship, STOCK_DELIVERY);
    } else {
      r.ship = addWorkdays(today, ORD_SHIP);
      r.shipsToday = false;
      r.shipFrom = r.shipTo = r.ship;
      r.from = addWorkdays(r.ship, ORD_MIN);
      r.to = addWorkdays(r.ship, ORD_MAX);
    }
    return r;
  }

  function fmt(dt) { return WD[dt.getUTCDay()] + ' ' + dt.getUTCDate() + ' ' + MO[dt.getUTCMonth()]; }
  function fmtShortRange(a, b) {
    if (key(a) === key(b)) return fmt(a);
    if (a.getUTCMonth() === b.getUTCMonth()) return a.getUTCDate() + '–' + b.getUTCDate() + ' ' + MO[b.getUTCMonth()];
    return a.getUTCDate() + ' ' + MO[a.getUTCMonth()] + ' – ' + b.getUTCDate() + ' ' + MO[b.getUTCMonth()];
  }
  function propText(e) { return key(e.from) === key(e.to) ? fmt(e.from) : fmt(e.from) + ' – ' + fmt(e.to); }

  function tipoVariante(v) {
    if (!v) return null;
    if (v.m === false) return 'stock';      // inventario non tracciato
    if (v.q > 0) return 'stock';
    if (v.p === 'continue') return 'ordinabile';
    return null;                            // esaurito e non vendibile: non mostrare
  }

  var api = { estimate: estimate, tipoVariante: tipoVariante, fmt: fmt, fmtShortRange: fmtShortRange, propText: propText, isWorkday: isWorkday, key: key };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  window.ConsegnaStimata = api;

  // ---------- PAGINA PRODOTTO ----------
  function setHidden(form, name, value) {
    var sel = 'input[type="hidden"][name="properties[' + name + ']"]';
    var el = form.querySelector(sel);
    if (value == null) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'properties[' + name + ']';
      form.appendChild(el);
    }
    el.value = value;
  }

  function initWidget(root) {
    var data;
    try { data = JSON.parse(root.querySelector('script[type="application/json"]').textContent); }
    catch (err) { return; }

    function forms() {
      return Array.prototype.filter.call(document.querySelectorAll('form[action*="/cart/add"]'), function (f) {
        var id = f.querySelector('[name="id"]');
        return id && data[id.value];
      });
    }
    function currentId() {
      var f = forms()[0];
      if (f) return f.querySelector('[name="id"]').value;
      var u = new URLSearchParams(location.search).get('variant');
      return u && data[u] ? u : root.getAttribute('data-default-variant');
    }

    var lastId = null, lastMinute = null;
    function render(force) {
      var id = currentId();
      var minute = romeNow().h * 60 + romeNow().min;
      if (!force && id === lastId && minute === lastMinute) return;
      lastId = id; lastMinute = minute;

      var tipo = tipoVariante(data[id]);
      var fs = forms();
      if (!tipo) {
        root.hidden = true;
        fs.forEach(function (f) { setHidden(f, PROP, null); setHidden(f, PROP_TYPE, null); setHidden(f, PROP_CALC, null); });
        return;
      }
      var e = estimate(tipo);
      root.hidden = false;
      root.setAttribute('data-tipo', tipo);
      root.querySelector('[data-cs-order]').textContent = fmt(e.order);
      root.querySelector('[data-cs-ship]').textContent = fmtShortRange(e.shipFrom, e.shipTo);
      root.querySelector('[data-cs-delivery]').textContent = fmtShortRange(e.from, e.to);

      var note = root.querySelector('[data-cs-note]');
      if (tipo === 'stock') {
        var txt = 'Disponibile in magazzino · consegna in ' + STOCK_DELIVERY + ' giorni lavorativi dalla spedizione';
        if (e.shipsToday) {
          var left = CUTOFF_HOUR * 60 - minute, h = Math.floor(left / 60), m = left % 60;
          txt = 'Ordina entro <strong>' + (h ? h + ' h ' : '') + m + ' min</strong> per la spedizione oggi';
        }
        note.innerHTML = txt;
      } else {
        note.textContent = 'Articolo ordinabile · spedizione in ' + ORD_SHIP + ' giorni lavorativi, consegna ' + ORD_MIN + '–' + ORD_MAX + ' giorni lavorativi dopo';
      }

      fs.forEach(function (f) {
        setHidden(f, PROP, propText(e));
        setHidden(f, PROP_TYPE, tipo);
        setHidden(f, PROP_CALC, key(e.ship));
      });
    }

    render(true);
    document.addEventListener('change', function () { setTimeout(function () { render(true); }, 50); });
    document.addEventListener('variant:changed', function () { render(true); });
    setInterval(render, 500); // segue anche i cambi variante fatti dal tema via JS
  }

  // ---------- CARRELLO: aggiorna le date se calcolate in un altro giorno ----------
  function refreshCart() {
    if (!window.fetch) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var todo = cart.items.filter(function (it) {
        var p = it.properties || {};
        return p[PROP_TYPE] && p[PROP_CALC] !== key(estimate(p[PROP_TYPE]).ship);
      });
      if (!todo.length) return;
      var chain = Promise.resolve();
      todo.forEach(function (it) {
        chain = chain.then(function () {
          var p = {}, e = estimate(it.properties[PROP_TYPE]);
          Object.keys(it.properties).forEach(function (k) { if (it.properties[k] != null) p[k] = it.properties[k]; });
          p[PROP] = propText(e);
          p[PROP_CALC] = key(e.ship);
          return fetch('/cart/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: p })
          });
        });
      });
      chain.then(function () { if (/^\/cart\/?$/.test(location.pathname)) location.reload(); });
    }).catch(function () {});
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-consegna-stimata]'), initWidget);
    refreshCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
